import { FC } from "react";
import ProvidersView from "modules/Home/views/ProvidersView/ProvidersView";
import ProviderFiltersView from "./Home/views/ProviderFiltersView/ProviderFiltersView";
import TemplatesView from "./Templates/views/TemplatesView";
import Header from "components/Header/Header";
import ChatBot from "components/Chatbot/Chatbot";
import MyProfile from "./MyProfile/MyProfile";
import { Route, Routes } from "react-router-dom";
import Graphs from "./Graphs/Graphs";
import RolesManagement from "./RolesManagement/RolesManagement";
import { useRoles } from "utils/hooks/useRoles";

const MainRouter: FC = () => {
  const { isAdmin } = useRoles();

  return (
    <div>
      <Header />
      <Routes>
        <Route path="/" element={<ProvidersView />} />
        <Route path="/Providers" element={<ProvidersView />} />
        <Route path="/Providers/:id" element={<ProviderFiltersView />} />
        <Route path="/Templates" element={<TemplatesView />} />
        <Route path="/Graphs" element={<Graphs />} />
        <Route path="/MyProfile" element={<MyProfile />} />
        {isAdmin && (
          <Route path="/RolesManagement" element={<RolesManagement />} />
        )}
      </Routes>
      <ChatBot />
    </div>
  );
};

export default MainRouter;
